/**
 * household.ts
 * [Readme] --------------------------------------------------------------------------------------
 * 
 * 세대 탭에서 사용하는 데이터의 모음입니다.
 * 일부 데이터는 직접 세대 페이지 컴포넌트에 넣는 경우도 존재합니다.
 * 
 * -----------------------------------------------------------------------------------------------
 */

import img1_1 from 'assets/Desktop/images/parcelOut/planimages_84a.png';
import img2_1 from 'assets/Desktop/images/parcelOut/pyposition_84a.png';
import img2_1_big from 'assets/Desktop/images/parcelOut/pyposition_84a_big.png';
import img3_1 from 'assets/Desktop/images/parcelOut/groundplan_84a.png';
import img4_1 from 'assets/Desktop/images/parcelOut/household-floor-plan-1-1.png';

import img1_2 from 'assets/Desktop/images/parcelOut/planimages_84b.png';
import img2_2 from 'assets/Desktop/images/parcelOut/pyposition_84b.png';
import img2_2_big from 'assets/Desktop/images/parcelOut/pyposition_84b_big.png';
import img3_2 from 'assets/Desktop/images/parcelOut/groundplan_84b.png';
import img4_2 from 'assets/Desktop/images/parcelOut/household-floor-plan-2-1.png';

import img1_3 from 'assets/Desktop/images/parcelOut/planimages_109.png';
import img2_3 from 'assets/Desktop/images/parcelOut/pyposition_109.png';
import img2_3_big from 'assets/Desktop/images/parcelOut/pyposition_109_big.png';
import img3_3 from 'assets/Desktop/images/parcelOut/groundplan_109.png';
import img4_3 from 'assets/Desktop/images/parcelOut/household-floor-plan-3-1.png';

import pdf1 from 'assets/common/221111_finishlist.pdf';
import pdf2 from 'assets/common/221111_squremeasure.pdf';

/**
 * 평방미터를 평형으로 계산하기 위한 기본 고정 값입니다.
 * 평방미터 * CAL_FEET 하여 처리하며 Math.floor(평방미터 * CAL_FEET)를 하여 소수점을 없앱니다.
 * 기준은 공급 면적입니다.
 */
const CAL_FEET: number = 0.3025;

/**
 * 세대 탭의 평면 정보 메뉴에서 사용하는 데이터 목록
 */
export const listContent = [
  {
    id: 1,
    img1: img1_1,
    img2: img2_1,
    img2_big: img2_1_big,
    img3: img3_1,
    img4: img4_1,
    tit: '84㎡A',
    tit2: `${Math.floor(111.0626 * CAL_FEET)}평A형`,
    subtit: '428세대',
    subtit2: '우수한 개방감과 여유로운 공간구성, 주방 원스톱 세탁실 등을 갖춰 생활의 편리함을 극대화한 판상형 구조',
    titcontent1: '평면타입',
    titcontent2: '단지 배치도',
    titcontent3: '비확장',
    titcontent4: '발코니 확장+추가선택품목',
    residential_area: '84.9800㎡',          // 전용 면적
    common_residential_area: '26.0826㎡',   // 공용 면적
    supply_area: '111.0626㎡',              // 공급 면적
    other_common_areas: '36.5812㎡',        // 기타 공용면적
    // underground_parking_lot: '61.9762㎡',   // 지하주차장
    contract_area: '147.6438㎡',            // 계약 면적
    footer: true,
    swiper: [
      {
        img: img3_1,
        title: '기본형'
      },
      {
        img: img4_1,
        title: '발코니 확장+추가선택품목'
      }
    ],
    addInfo: `
    ①현관 중문 ②침실2 붙박이장 ③침실3 붙박이장 ④하이브리드 쿡탑/인덕션 
      \n※ 천장형 시스템에어컨 및 주방 빌트인 가전제품은 별도 확인 바랍니다.
      \n※ 추가선택품목 관련 자세한 사항은 입주자모집공고를 참조하시기 바랍니다.
    `
  },
  {
    id: 2,
    img1: img1_2,
    img2: img2_2,
    img2_big: img2_2_big,
    img3: img3_2,
    img4: img4_2,
    tit: '84㎡B',
    tit2: `${Math.floor(112.1926 * CAL_FEET)}평B형`,
    subtit: '57세대',
    subtit2: '더 넓어진 개방감으로 채광과 통풍이 우수하고, 넉넉한 주방공간과 드레스룸이 갖춰진 코너 판상형 구조',
    titcontent1: '평면타입',
    titcontent2: '단지 배치도',
    titcontent3: '비확장',
    titcontent4: '발코니 확장+추가선택품목',
    residential_area: '84.9000㎡',          // 주거 전용 면적
    common_residential_area: '27.2926㎡',   // 주거 공용 면적
    supply_area: '112.1926㎡',              // 공급 면적
    other_common_areas: '36.5510㎡',        // 기타 공용면적
    // underground_parking_lot: '61.8516㎡',   // 지하주차장
    contract_area: '148.7436㎡',            // 계약 면적
    footer: true,
    swiper: [
      {
        img: img3_2,
        title: '기본형'
      },
      {
        img: img4_2,
        title: '발코니 확장+추가선택품목'
      }
    ],
    addInfo: `
    ①현관 중문 ②침실2 붙박이장 ③침실3 붙박이장 ④하이브리드 쿡탑/인덕션
    \n※ 천장형 시스템에어컨 및 주방 빌트인 가전제품은 별도 확인 바랍니다.
    \n※ 추가선택품목 관련 자세한 사항은 입주자모집공고를 참조하시기 바랍니다.
    `
  },
  {
    id: 3,
    img1: img1_3,
    img2: img2_3,
    img2_big: img2_3_big,
    img3: img3_3,
    img4: img4_3,
    tit: '109㎡',
    tit2: `${Math.floor(141.9951 * CAL_FEET)}평`,
    subtit: '60세대',
    subtit2: '넉넉한 거실과 주방, 알파공간을 갖추어 공간은 보다 더 여유로우며, 맞통풍 평면설계를 통해 채광과 환기를 극대화한 판상형 구조',
    titcontent1: '평면타입',
    titcontent2: '단지 배치도',
    titcontent3: '비확장',
    titcontent4: '발코니 확장+추가선택품목',
    residential_area: '109.4000㎡',          // 주거 전용 면적
    common_residential_area: '32.5951㎡',   // 주거 공용 면적
    supply_area: '141.9951㎡',              // 공급 면적
    other_common_areas: '47.0981㎡',        // 기타 공용면적
    underground_parking_lot: '62.0368㎡',   // 지하주차장
    contract_area: '189.0932㎡',            // 계약 면적
    footer: true,
    swiper: [
      {
        img: img3_3,
        title: '기본형'
      },
      {
        img: img4_3,
        title: '발코니 확장+추가선택품목'
      }
    ],
    addInfo: `
    ①현관 중문 ②침실2 붙박이장 ③침실3 붙박이장 ④하이브리드 쿡탑/인덕션
      \n※ 천장형 시스템에어컨 및 주방 빌트인 가전제품은 별도 확인 바랍니다.
      \n※ 추가선택품목 관련 자세한 사항은 입주자모집공고를 참조하시기 바랍니다.
    `
  }
];


/**
 * 파일 목록
 */
 export const listContentFile = [
  {
    title: '마감재리스트 확인',
    file: pdf1
  },
  {
    title: '주택형별 면적 확인',
    file: pdf2
  }
]